import GeneratorForm from '../../../components/GeneratorForm/GeneratorForm.jsx';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { authFetch } from '../../../utils/apiClient.js';
import { fakeResponse } from '../../../utils/helpers.js';
import { mockProduct } from '../../../utils/mockData';
import AccessModal from '../../../components/Modal/AccessModal.jsx';
import DemoModal from '../../../components/Modal/DemoModal.jsx';
import useAccessType from '../../../hooks/useAccessType.js';

function ProductKeywordScreen() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { getAccessType, isDemo } = useAccessType();
    const [modalType, setModalType] = useState(null);
    const [keyword, setKeyword] = useState(null);

    async function generateProduct(language, tone, contentLength, subject, keywords) {
        try {
            const res = await authFetch("/api/product/generate", {
                method: "POST",
                body: JSON.stringify({
                    language,
                    tone,
                    contentLength,
                    subject,
                    keywords
                })
            });

            return await res.json();
        } catch (error) {
            console.error("Error generating product:", error);
            return null;
        }
    }

    async function generateFakeProduct() {
        return fakeResponse(mockProduct)
    }

    const handleSubmit = async (formData) => {
        const { language, tone, contentLength, subject, keywords } = formData;
        if (isDemo) {
            setKeyword(subject);
            setShowModal(true);
            return;
        }
        const accessType = getAccessType();
        if (accessType) {
            setModalType(accessType);
            setShowModal(true);
            return;
        }

        setIsLoading(true);
        const data = await generateProduct(language, tone, contentLength, subject, keywords);
        navigate('/product/generated', { state: { product: data, keyword: subject } });
    };

    const handleDemo = async () => {
        setIsLoading(true);
        const data = await generateFakeProduct();
        navigate('/product/generated', { state: { product: data, keyword } });
    };

    return (
        <>
            <GeneratorForm
                onSubmit={handleSubmit}
                isLoading={isLoading}
            />
            <AccessModal
                show={showModal && !isDemo}
                setShow={setShowModal}
                modalType={modalType}
            />
            <DemoModal
                show={showModal && isDemo}
                setShow={setShowModal}
                onAction={handleDemo}
            />
        </>
    );
}

export default ProductKeywordScreen;